import { render, staticRenderFns } from "./YoutubeConfig.vue?vue&type=template&id=d43caa7a&scoped=true"
import script from "./YoutubeConfig.vue?vue&type=script&lang=js"
export * from "./YoutubeConfig.vue?vue&type=script&lang=js"
import style0 from "./YoutubeConfig.vue?vue&type=style&index=0&id=d43caa7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d43caa7a",
  null
  
)

export default component.exports